var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"call-view"},[(_vm.loading('room'))?_c('loading-screen'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }